import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { baseColors, DotLoader, RelodeTheme } from "..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            jobViewsTile: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flexDirection: "column",
                flexGrow: 0.1,
                [theme.breakpoints.down("sm")]: {
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: theme.spacing(2),
                },
            },
            statTileTitle: {
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_regular"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
                fontSize: 16,
                lineHeight: "22px",
                color: baseColors.gray,
                marginBottom: theme.spacing(0.5),
            },
            statTileContent: {
                fontSize: 28,
                fontStyle: "normal",
                lineHeight: "34px",
                height: "34px",
                fontWeight: "bold",
                margin: 0,
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_bold"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
                color: baseColors.navy,
            },
            statTileContentLoader: {
                marginLeft: theme.spacing(2),
                [theme.breakpoints.down("sm")]: {
                    marginLeft: 0,
                },
            },
        }),
    { name: "StatTile" }
);
interface JobViewTileProps {
    id: string;
    title: string;
    totalCount: string;
    uniqueCount?: string;
    isBusy?: boolean;
}

export const JobViewTile = (props: JobViewTileProps) => {
    const classes = useStyles(props);
    const { id, title, totalCount, uniqueCount = "", isBusy } = props;

    return (
        <div id={id} className={classes.jobViewsTile}>
            <div className={classes.statTileTitle}>{title}</div>

            <div className={classes.statTileContent}>
                {isBusy ? (
                    <DotLoader className={classes.statTileContentLoader} />
                ) : (
                    totalCount
                )}
            </div>
            {uniqueCount !== "" ? <div>{uniqueCount} unique</div> : null}
        </div>
    );
};
